module.exports = __webpack_public_path__ + "assets/img/additionalproduct.c2e5755c.svg";